export default {
  customers: [],
  count: 0,
  lastFilter: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/state.js